import React, {Fragment, useState, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import {Container, Col, Row} from 'reactstrap';
import HeadLineComponent from './HeadLineComponent';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';
import DeniedMessageBox from '../../Shared/DeniedMessageBox/DeniedMessageBox';
import RadioInput from '../../Shared/RadioInput/RadioInput';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';
import {gaReportShownPage, gaReportSelectedOrgId, gaShowCompanyType, gaReportOnButtonClick} from './gaReports';
import radioBtnOnIcon from './images/radio-btn/radio-btn-on.svg';

const SelectCompanyComponent = ({props, setSelectedForUpdate, backToLobby}) => {
  if (props.data.currentStep !== 2) {
    return null;
  }

  const [animateOut, setAnimateOut] = useState(false);

  const selectBoxObj = [];

  props.data.orgDetailList.map((org) => {
    let item = {key: org.idNumber, value: org.orgName + ' ' + org.idNumber};
    selectBoxObj.push(item);
  });

  const messageText = 'אנחנו צריכים הרשאה מתאימה כדי להמשיך - </br> במוקד השירות העסקי שלנו ישמחו לעזור ';
  const subMessageText = `חיוג 234* לעדכון הרשאה`;

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    validateDefaultCompany();
    if (props.data.isBusinessBlock) {
      gaReportShownPage('select_company');
      gaReportSelectedOrgId(props.data.orgDetailList.length);
    }

    setTimeout(() => {
      props.setProgressBarPercent(20);
    }, props.data.animationTimeOut);
  }, []);

  //animation
  useEffect(() => {
    if (props.data.selectedForUpdate && props.data.submitAnimation) {
      setAnimateOut(true);
      setTimeout(() => {
        props.handleCurrentStep(3);
      }, props.data.animationTimeOut);
    }
  }, [props.data.selectedForUpdate]);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
  }, [props.data.selectedCompanyId]);

  const validateDefaultCompany = () => {
    if (props.data.orgDetailList.length === 1 || props.selectedFromPortal != '') {
      const selectedCompany = props.selectedFromPortal == '' ? props.data.orgDetailList[0].idNumber : props.selectedFromPortal;
      validateSelectedOrg(selectedCompany);
    }
  };

  const validateSelectedOrg = (selectedOrgId) => {
    props.setMultiple(false);
    props.setForbidden(false);

    if (selectedOrgId) {
      props.setSelectedCompanyId(selectedOrgId);
      const selectedOrg = props.data.orgDetailList.find((org) => org.idNumber == selectedOrgId);

      if (
        selectedOrg?.cellInd &&
        selectedOrg?.netvInd &&
        (selectedOrg?.bussinesContactRole.isActionAllowedCellcom || selectedOrg?.bussinesContactRole.isActionAllowedNv)
      ) {
        props.setMultiple(true);
        gaShowCompanyType(); //ga
      } else {
        if (selectedOrg?.cellInd && !selectedOrg?.netvInd && selectedOrg?.bussinesContactRole.isActionAllowedCellcom) {
          props.setSelectedProvider('Cellcom');
        } else if (!selectedOrg?.cellInd && selectedOrg?.netvInd && selectedOrg?.bussinesContactRole.isActionAllowedNv) {
          props.setSelectedProvider('Netvision');
        } else {
          setForbiddenAndGaEvent();
        }
      }
    }
    props.saveToHistory();
  };

  const onRadioBtnChange = (e) => {
    let value = e.currentTarget.value;
    props.setSelectedProvider(value);
    props.saveToHistory();
  };

  const validateIfAllowedContinue = () => {
    gaReportOnButtonClick('select_company_page_continue_to_the_next_step_btn');

    let ans = true;
    const selectedOrg = props.data.orgDetailList.find((org) => org.idNumber == props.data.selectedCompanyId);

    if (props.data.ifMultiple) {
      ans =
        (props.data.selectedProvider == 'Cellcom' && selectedOrg.bussinesContactRole.isActionAllowedCellcom) ||
        (props.data.selectedProvider == 'Netvision' && selectedOrg.bussinesContactRole.isActionAllowedNv)
          ? true
          : false;
    }

    if (ans) {
      gaEvent(
        gaParams.UPDATE_PAYMENT_METHOD_SELECTED_COMPANYTYPE.category,
        gaParams.UPDATE_PAYMENT_METHOD_SELECTED_COMPANYTYPE.eventType,
        props.data.selectedProvider
      );
      setSelectedForUpdate(selectedOrg.idNumber, props.data.selectedProvider);
    } else {
      setForbiddenAndGaEvent();
    }
  };

  const setForbiddenAndGaEvent = () => {
    props.setForbidden(true);
    gaEvent(
      gaParams.UPDATE_PAYMENT_METHOD_SHOW_NO_PERM.category,
      gaParams.UPDATE_PAYMENT_METHOD_SHOW_NO_PERM.eventType,
      gaParams.UPDATE_PAYMENT_METHOD_SHOW_NO_PERM.eventParams
    );
  };

  const gaAndbackToBusinessLobby = () => {
    gaReportOnButtonClick('select_company_back_to_business_lobby_btn');
    backToLobby();
  };

  return !props.data.isBusinessBlock ? null : (
    <div className={`${animateOut ? 'animateOut' : 'animateIn'}`}>
      <HeadLineComponent text={'עדכון אמצעי תשלום'} />
      <Container>
        <Row>
          <Col className='p-0'>
            <div className={`background-container ${props.data.ifForbidden ? 'with-error' : ''}`}>
              <p className='bold text-right'>על איזה ח.פ מדובר?</p>
              <ReactSelect
                className={`${props.data.orgDetailList.length === 1 ? 'disabled' : ''}`}
                getOptionLabel={(option) => option.value}
                getOptionValue={(option) => option.key}
                placeholder='בחירת ח.פ.'
                value={selectBoxObj.filter((option) => option.key == props.data.selectedCompanyId)}
                name='selected'
                options={selectBoxObj}
                onChange={(e) => validateSelectedOrg(e.key)}
              />
            </div>
          </Col>
        </Row>
        {props.data.ifMultiple && !props.data.ifForbidden && (
          <Row>
            <Col className='p-0'>
              <div className='background-container'>
                <p className='bold text-right mb-0'>בחירת סוג החשבון</p>

                {props.data.selectProviderRadioBtns.map((btn) => (
                  <div className='radio-btn-item' key={btn.id}>
                    <RadioInput
                      checked={props.data.selectedProvider == btn.value}
                      id={btn.id}
                      name='consumer'
                      value={btn.value}
                      label={btn.label}
                      checkedIcon={radioBtnOnIcon}
                      onChange={onRadioBtnChange}
                    />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        )}

        {props.data.ifForbidden && (
          <Row>
            <Col className='p-0'>
              <DeniedMessageBox text={messageText} subText={subMessageText} asBtn={isMobile ? true : false} />
            </Col>
          </Row>
        )}

        <Row className='justify-content-md-center'>
          <Col xs='12' className={`${props.data.selectedCompanyId == null ? 'disabled-btn' : ''} btn-337 btn-row pr-0 pl-0 text-center`}>
            <BtnSubmit
              isBusiness={props.data.isBusinessBlock}
              text={`${!props.data.ifForbidden ? 'אפשר להתקדם' : 'חזרה לאזור העסקי'}`}
              onclick={() => {
                props.data.ifForbidden ? gaAndbackToBusinessLobby() : validateIfAllowedContinue();
              }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SelectCompanyComponent;
